import { useQuery } from '@tanstack/react-query';
import { useCorpAccountNumber } from 'hooks/useCorpAccountNumber';
import { getStockExchanges } from 'services';
import { STOCK_EXCHANGE_KEY } from '../constants';

export function useGetStockExchanges() {
  const { corpAccountNumber } = useCorpAccountNumber();
  const enabled = !!corpAccountNumber;

  return useQuery([STOCK_EXCHANGE_KEY], {
    queryFn: () => getStockExchanges(corpAccountNumber),
    enabled,
  });
}
